/**
 * Screen 相关
 */
const {
  DEVICE_TYPE_LIST,
  MEDIA_TYPE_LIST,
} = require('../../options/device.js');
const { LANG_TYPE } = require('../../options/lang.js');
const defaultValues = require('./default.js');

let $i18n = { r: (v) => v, rp: () => [] };

const i18n = {
  key: 'i18n',
  type: 'Object',
  label: '多语言',
  default: defaultValues.i18n,
  noCompile: true,
  options: () => {
    let __system = {
      custom: '自定义',
      __variables__: '组件变量',
    };
    let data = $i18n.messages[$i18n.fallbackLocale] || {};
    return Object.keys(data).map((k, i) => ({
      value: k,
      label: __system[k] ?? k,
      index: __system[k] ? i : 10 + i,
    }));
  },
  init: (func) => {
    $i18n = func;
  },
  rp: (v, dataInject) => {
    return $i18n.rp(v, dataInject);
  },
  convert: (v, dataInject = {}) => {
    return $i18n.r(v, dataInject);
  },
};

const locale = {
  key: 'locale',
  type: 'String',
  label: '区域',
  default: defaultValues.locale,
  noCompile: true,
  options: () => {
    let availableLocales = $i18n.availableLocales;
    return availableLocales.map((k) => {
      let r = LANG_TYPE.find((o) => o.value === k);
      if (r === undefined)
        return {
          label: k,
          value: k,
        };
      else return r;
    });
  },
};

module.exports = {
  version: {
    key: 'version',
    type: 'Object',
    label: '版本号',
    default: defaultValues.version,
    tip: '保存数据时的编辑器版本与属性库版本',
  },
  blockly: {
    key: 'blockly',
    type: 'Array',
    label: 'blockly',
    default: defaultValues.blockly,
    noCompile: true,
    tip: '事件相关源码',
  },
  site: {
    key: 'site',
    type: 'Object',
    label: '站点',
    default: defaultValues.site,
  },
  isRoot: {
    key: 'isRoot',
    type: 'Boolean',
    label: '文档根节点',
    default: defaultValues.isRoot,
    noCompile: true,
  },
  isScreen: {
    key: 'isScreen',
    type: 'Boolean',
    label: 'Screen 类型',
    default: defaultValues.isScreen,
    static: true,
    noCompile: true,
  },
  isTemplate: {
    key: 'isTemplate',
    type: 'Boolean',
    label: '模板',
    default: defaultValues.isTemplate,
    static: true,
    tip: '是否是模板；由其它属性计算得出，不需要赋值',
    noCompile: true,
  },
  primaryFrameId: {
    key: 'primaryFrameId',
    type: 'String',
    label: '主页 ID',
    default: defaultValues.primaryFrameId,
  },
  ads: {
    key: 'ads',
    type: 'Object',
    label: 'ADS',
    default: defaultValues.ads,
    // i18n: true,
    i18n: {
      fb: true,
      gg: true,
      tt: true,
      re: true,
      tw: true,
    },
  },
  seo: {
    key: 'seo',
    type: 'Object',
    label: 'SEO',
    default: defaultValues.seo,
    i18n: {
      keywords: true,
      description: true,
      image: true,
    },
  },
  og: {
    key: 'og',
    type: 'Object',
    label: 'OG',
    default: defaultValues.og,
    i18n: {
      title: true,
      description: true,
      image: true,
      twiterCard: true,
      site_name: true,
      alternateName: true,
      url: true,
    },
  },
  webTitle: {
    key: 'webTitle',
    type: ['String', 'Object'],
    label: 'webTitle',
    default: defaultValues.webTitle,
    i18n: true,
  },
  globalCode: {
    key: 'globalCode',
    type: 'Array',
    label: 'globalCode',
    default: defaultValues.globalCode,
    noCompile: true,
  },
  timezone: {
    key: 'timezone',
    type: 'Object',
    label: '时区',
    default: defaultValues.timezone,
  },
  file_code: {
    key: 'file_code',
    type: 'String',
    label: 'file_code',
    default: defaultValues.file_code,
    noCompile: true,
  },
  code: {
    key: 'code',
    type: 'String',
    label: 'code',
    default: defaultValues.code,
    static: true,
    noCompile: true,
  },
  __rid: {
    key: '__rid',
    type: 'String',
    label: 'record id',
    default: defaultValues.__rid,
    tip: '本地存档编号',
    noCompile: true,
  },
  __prid: {
    key: '__prid',
    type: 'String',
    label: 'record id',
    default: defaultValues.__prid,
    tip: '上一次存档编号',
    noCompile: true,
  },
  updated: {
    key: 'updated',
    type: 'String',
    label: 'updated',
    default: defaultValues.updated,
    tip: '本地编辑时间',
  },
  deviceInfo: {
    key: 'deviceInfo',
    type: 'Object',
    label: '设备信息',
    default: defaultValues.deviceInfo,
    static: true,
    noCompile: true,
    options: { type: DEVICE_TYPE_LIST },
  },
  normalScreen: {
    key: 'normalScreen',
    type: 'Object',
    label: '设计稿',
    default: defaultValues.normalScreen,
  },
  adaptive: {
    key: 'adaptive',
    type: 'Object',
    label: '适配',
    default: defaultValues.adaptive,
    i18n: {
      background: true,
    },
    tip: '移动端以为的自动适配方案',
  },
  media: {
    key: 'media',
    type: 'Object',
    label: '媒体查询',
    default: defaultValues.media,
    options: { orientation: MEDIA_TYPE_LIST },
  },
  locale: locale,
  fallbackLocale: {
    key: 'locale',
    type: 'String',
    label: '默认区域',
    default: defaultValues.locale,
  },
  i18n: i18n,
  googleFonts: {
    key: 'googleFonts',
    type: 'Object',
    label: '谷歌字体',
    default: defaultValues.googleFonts,
  },
  remoteInfo: {
    key: 'remoteInfo',
    type: 'Object',
    label: '其它页面信息',
    default: defaultValues.remoteInfo,
    static: true,
    noCompile: true,
  },
  bodyColor: {
    key: 'bodyColor',
    type: 'bodyColor',
    label: '窗口背景颜色',
    default: defaultValues.bodyColor,
    noCompile: true,
  },
  formSchema: {
    key: 'formSchema',
    type: 'Object',
    label: '表单结构数据',
    default: defaultValues.formSchema,
    noCompile: true,
  },
  cypress: {
    key: 'cypress',
    type: 'Object',
    label: '测试相关数据',
    default: defaultValues.cypress,
    noCompile: true,
  },
  ossImgRatio: {
    key: 'ossImgRatio',
    type: 'Number',
    label: '图片适配',
    tip: '图片缩放百分比<br />图片需要导出双倍尺寸，会根据缩放比例加载单倍图<br />单倍尺寸 = 双倍尺寸 * 百分比（1-100）',
    default: defaultValues.ossImgRatio,
  },
};
